import { Box, Button, CircularProgress, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectPublico from "../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import SelectHistoricoCaixaBancos from "../../../../../../../components/SelectsSimpleApiQuery/SelectHistoricoCaixaBancos";

export default function Step02() {

  const { getValues, control, handleSubmit, setValue, watch } = useFormContext()

  const onSubmit = getValues('funcoesAux.onSubmit')
  const handleBackStep = getValues('funcoesAux.onBack')
  const isLoading = watch('isLoadingIncluirLancamento')

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.historico"
          control={control}
          render={({ field }) => (
            <SelectHistoricoCaixaBancos
              {...field}
              value={field.value}
              onChange={(valor) => {
                setValue('step02.historico', valor);
                setValue('step02.historico.descricao', valor?.descricao);
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.historico.descricao"
          control={control}
          render={({ field }) => (
            <TextField
              label="Descrição histórico"
              value={field.value || ''}
              fullWidth
              onChange={(e) => {
                setValue(`step02.historico.descricao`, e.target.value);
              }}
              slotProps={{ htmlInput: { maxLength: 30 } }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.publico"
          control={control}
          render={({ field }) => {
            return (
              <SelectPublico
                {...field}
                value={field.value}
                onChange={(valor) => {
                  field.onChange(valor)
                  setValue('step02.beneficiario', valor?.nome_pessoa)
                }}
              />
            )
          }}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.beneficiario"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              label="Beneficiário"
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              slotProps={{ htmlInput: { maxLength: 40 } }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.nr_documento"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              type="number"
              label="Número documento"
              value={field.value}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 10) {
                  field.onChange(inputValue);
                }
              }}

            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}></Grid>
      <Grid size={{ xs: 12 }}>
        <Box display={'flex'} gap={2}>
          <Button
            variant="outlined"
            onClick={handleBackStep}
            disabled={isLoading}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            disabled={isLoading}
          >
            {
              isLoading &&
              <CircularProgress size={20} sx={{ marginRight: 1 }} />
            }
            Finalizar
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}
